import {IonicPage, NavController, NavParams, Platform} from "ionic-angular";
import {Component} from "@angular/core";


//import {TranslateService} from "@ngx-translate/core";


/**
 * Generated class for the InstructionsPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-instructions',
  templateUrl: 'instructions.html',
})
export class InstructionsPage {

  private tag = '[INSTRUCTIONS]';

  isDeviceBarcode : boolean;
  private isPopActive: boolean = false;
  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private platform: Platform) {
    //public translate: TranslateService) {
    this.isDeviceBarcode = this.navParams.data.isDeviceBarcode;
  }

  ionViewDidLoad() {
    console.log(this.tag, 'ionViewDidLoad InstructionsPage');
  }

  goBack() {
    if(!this.isPopActive) {
      this.isPopActive = true;
      this.navCtrl.pop().then(() => {
      });
    }
  }

  ionViewWillEnter() {
    this.platform.registerBackButtonAction(() => {
      this.goBack();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/instructions/instructions.ts